import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import {
  ICreateNewSubmissionByQuizId,
  createNewSubmissionByQuizId,
} from '../../store/SubmissionSlice';
import { getQuizById, getQuizState } from '../../store/QuizSlice';
import { useAppSelector } from '../../hooks';
import FullScreenLoader from '../../components/Loaders/FullScreenloader';

const StartSubmission: React.FC = () => {
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  // Store
  const quizState = useAppSelector(getQuizState);

  const queryStringParams = new URLSearchParams(
    (location.hash || '').substring(1)
  );

  const quizId = params.quizId || '';
  const quizData = quizState.quiz;
  const homeworkId = queryStringParams.get('homeworkId') || '';

  useEffect(() => {
    if (quizId) {
      dispatch(getQuizById(quizId));
    }
  }, []);

  useEffect(() => {
    if (quizData) {
      const { subTopics } = quizData;

      if (subTopics && subTopics.length) {
        const item = subTopics[0];

        if (item && item.subTopic && item.subTopic._id) {
          const apiData: ICreateNewSubmissionByQuizId = {
            quizId,
            subTopicId: item.subTopic._id,
          };

          if (homeworkId) {
            apiData.homeworkId = homeworkId;
          }

          dispatch(createNewSubmissionByQuizId(apiData));
        }
      }
    }
  }, [quizData]);

  return <FullScreenLoader />;
};

export default StartSubmission;
